export enum LoanStatus {
    Incomplete = 1,
    Investigation = 2,
    Denied = 3,
    Granted = 4,
    GrantedSelected = 5,
    Sent = 6,
    Paid = 7
}
